(function () {
    if (window.productProfileSectionsRenderLoaded) return;
    window.productProfileSectionsRenderLoaded = true;

    var isFetchingSections = false;

    function getSectionsToRender(limit) {
        var productPage = document.querySelector(".product-page.product-template");
        var productSection = productPage ? productPage.closest(".shopify-section") : null;
        var sectionsWrapper;

        if (productSection) {
            return [{
                id: productSection.id,
                section: productSection.id.replace("shopify-section-", ""),
                selector: "#" + productSection.id
            }];
        }

        sectionsWrapper = document.getElementById("content");
        if (!sectionsWrapper) return [];

        return Array.prototype.slice.call(sectionsWrapper.querySelectorAll(".shopify-section"))
            .slice(0, limit)
            .map(function (section) {
                return {
                    id: section.id,
                    section: section.id.replace("shopify-section-", ""),
                    selector: "#" + section.id
                };
            });
    }

    function getSectionInnerHTML(html, selector) {
        var parsedDocument = new DOMParser().parseFromString(html, "text/html");
        var element = parsedDocument.querySelector(selector);
        return element ? element.innerHTML : "";
    }

    function executeScriptsFromHTML(html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var scripts = doc.querySelectorAll("script");

        Array.prototype.forEach.call(scripts, function (script) {
            var scriptContent = script.textContent ? script.textContent.trim() : "";

            if (script.src) {
                if (!document.querySelector('script[src="' + script.src + '"]')) {
                    var newScript = document.createElement("script");
                    newScript.src = script.src;
                    newScript.async = true;
                    document.body.appendChild(newScript);
                }
            } else if (scriptContent && scriptContent.charAt(0) !== "{" && scriptContent.charAt(0) !== "[") {
                var inlineScript = document.createElement("script");
                inlineScript.textContent = scriptContent;
                document.body.appendChild(inlineScript);
            }
        });
    }

    function requestText(url) {
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.open("GET", url, true);
            request.onload = function () {
                if (request.status >= 200 && request.status < 300) {
                    resolve(request.responseText);
                } else {
                    reject(new Error("Request failed"));
                }
            };
            request.onerror = reject;
            request.send();
        });
    }

    function currentProductUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete("sections");
        url.hash = "";
        return url.toString();
    }

    function getProfileOrder() {
        var swatch = document.querySelector(".swatch.profile");
        if (!swatch) return [];

        return Array.prototype.slice.call(swatch.querySelectorAll("[data-swatch-value]"))
            .map(function (item) {
                return item.getAttribute("data-swatch-value");
            })
            .filter(Boolean);
    }

    function getSwatchOrder(selector) {
        var swatch = document.querySelector(selector);
        if (!swatch) return [];

        return Array.prototype.slice.call(swatch.querySelectorAll("[data-swatch-value]"))
            .map(function (item) {
                return item.getAttribute("data-swatch-value");
            })
            .filter(Boolean);
    }

    function getPreservedStarRatings() {
        var starRatings = {};

        Array.prototype.forEach.call(document.querySelectorAll("[data-profile-preserve-yotpo-stars]"), function (element) {
            var key = element.getAttribute("data-profile-preserve-yotpo-stars");
            if (key) starRatings[key] = element.innerHTML;
        });

        return starRatings;
    }

    function restorePreservedStarRatings(starRatings) {
        if (!starRatings) return;

        Array.prototype.forEach.call(document.querySelectorAll("[data-profile-preserve-yotpo-stars]"), function (element) {
            var key = element.getAttribute("data-profile-preserve-yotpo-stars");
            if (key && Object.prototype.hasOwnProperty.call(starRatings, key)) {
                element.innerHTML = starRatings[key];
            }
        });
    }

    function getSelectedOptions() {
        return Array.prototype.slice.call(document.querySelectorAll(".swatch"))
            .filter(function (swatch) {
                var optionName = swatch.getAttribute("data-option-name") || "";
                return optionName.toLowerCase().indexOf("profile") === -1;
            })
            .map(function (swatch) {
                var input = swatch.querySelector('input[type="radio"]:checked');
                var optionName = swatch.getAttribute("data-option-name");

                return input && optionName ? {
                    name: optionName,
                    value: input.value
                } : null;
            })
            .filter(Boolean);
    }

    function getSelectedColorHandle() {
        var selectedColorInput = document.querySelector('.swatch.color input[type="radio"]:checked');
        var selectedColorItem = selectedColorInput ? selectedColorInput.closest("[data-swatch-color]") : null;

        if (!selectedColorItem) {
            selectedColorItem = document.querySelector(".swatch.color [data-swatch-color].active");
        }

        return selectedColorItem ? selectedColorItem.getAttribute("data-swatch-color") : "";
    }

    function getScrollY() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function stopScrollAnimations() {
        if (window.jQuery) {
            window.jQuery("html, body").stop(true, true);
        }
    }

    function restoreScrollPosition(scrollY) {
        if (typeof scrollY !== "number") return;

        stopScrollAnimations();
        window.scrollTo(window.pageXOffset || 0, scrollY);

        setTimeout(function () {
            stopScrollAnimations();
            window.scrollTo(window.pageXOffset || 0, scrollY);
        }, 50);
    }

    function parseProfileColorUrls(value) {
        var urls = {};

        (value || "").split("||").forEach(function (entry) {
            var parts = entry.split("::");

            if (parts[0] && parts[1]) {
                urls[parts[0]] = parts[1];
            }
        });

        return urls;
    }

    function getProfileUrlForSelectedColor(anchor) {
        var selectedColorHandle = getSelectedColorHandle();
        var profileColorUrls = parseProfileColorUrls(anchor.getAttribute("data-profile-color-urls"));

        return selectedColorHandle && profileColorUrls[selectedColorHandle] ? profileColorUrls[selectedColorHandle] : "";
    }

    function filterProfilesForSelectedColor() {
        var selectedColorHandle = getSelectedColorHandle();
        var profileSwatch = document.querySelector(".swatch.profile");

        if (!selectedColorHandle || !profileSwatch) return;

        Array.prototype.forEach.call(profileSwatch.querySelectorAll("[data-swatch-value]"), function (profileItem) {
            var profileColorUrls = parseProfileColorUrls(profileItem.getAttribute("data-profile-color-urls"));
            var isCurrentProfile = profileItem.hasAttribute("data-current") || profileItem.classList.contains("active");
            var isAvailableForColor = Object.prototype.hasOwnProperty.call(profileColorUrls, selectedColorHandle);
            var shouldShow = isCurrentProfile || isAvailableForColor;
            var input = profileItem.querySelector('input[type="radio"]');

            profileItem.classList.toggle("hide", !shouldShow);
            profileItem.setAttribute("aria-hidden", shouldShow ? "false" : "true");
            if (input) input.disabled = !shouldShow;
        });
    }

    function scheduleProfileFilter() {
        window.setTimeout(filterProfilesForSelectedColor, 0);
    }

    function findSwatch(optionName) {
        var swatches = document.querySelectorAll(".swatch");

        for (var i = 0; i < swatches.length; i += 1) {
            if (swatches[i].getAttribute("data-option-name") === optionName) {
                return swatches[i];
            }
        }

        return null;
    }

    function findInputByValue(swatch, value) {
        var inputs = swatch.querySelectorAll('input[type="radio"]');

        for (var i = 0; i < inputs.length; i += 1) {
            if (inputs[i].value === value) return inputs[i];
        }

        return null;
    }

    function triggerChange(input) {
        var event;

        if (typeof Event === "function") {
            event = new Event("change", { bubbles: true });
        } else {
            event = document.createEvent("Event");
            event.initEvent("change", true, true);
        }

        input.dispatchEvent(event);
    }

    function restoreSelectedOptions(selectedOptions) {
        selectedOptions.forEach(function (selectedOption) {
            var swatch = findSwatch(selectedOption.name);
            var input = swatch ? findInputByValue(swatch, selectedOption.value) : null;
            var currentOption = swatch ? swatch.querySelector(".current-option") : null;
            var isColorOption = /^(color|colour)$/i.test(selectedOption.name);
            var wasChecked = input ? input.checked : false;

            if (!input || (input.parentElement && input.parentElement.classList.contains("hide"))) return;

            input.checked = true;
            if (currentOption) currentOption.textContent = selectedOption.value;
            if (isColorOption && wasChecked) return;

            triggerChange(input);
        });
    }

    function preserveProfileOrder(order) {
        preserveSwatchOrder(".swatch.profile", order);
    }

    function preserveSwatchOrder(selector, order) {
        var swatch = document.querySelector(selector);
        if (!swatch || !order.length) return;

        var items = Array.prototype.slice.call(swatch.querySelectorAll("[data-swatch-value]"));
        var orderedItems = [];

        order.forEach(function (value) {
            var matchedItem = items.find(function (item) {
                return item.getAttribute("data-swatch-value") === value;
            });

            if (matchedItem) orderedItems.push(matchedItem);
        });

        items.forEach(function (item) {
            if (orderedItems.indexOf(item) === -1) orderedItems.push(item);
        });

        orderedItems.forEach(function (item) {
            swatch.appendChild(item);
        });
    }

    function findProfileUrl(html, profileValue, fallbackUrl) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var items = doc.querySelectorAll(".swatch.profile [data-swatch-value]");

        for (var i = 0; i < items.length; i += 1) {
            if (items[i].getAttribute("data-swatch-value") === profileValue) {
                return items[i].getAttribute("data-href") || items[i].getAttribute("data-current") || fallbackUrl;
            }
        }

        return fallbackUrl;
    }

    function resolveProfileUrl(profileValue, fallbackUrl) {
        if (!profileValue) return Promise.resolve(fallbackUrl);

        return requestText(currentProductUrl())
            .then(function (html) {
                return findProfileUrl(html, profileValue, fallbackUrl);
            })
            .catch(function () {
                return fallbackUrl;
            });
    }

    function callThemeMethod(methodName) {
        if (window.theme && typeof window.theme[methodName] === "function") {
            window.theme[methodName]();
        }
    }

    function resetProductSectionEventListeners() {
        var productSectionEvents = [
            "product:updateUi",
            "productVideo:pauseAll",
            "swatch:change:1",
            "swatch:change:2",
            "swatch:change:3",
            "thumbnail:click",
            "variantchange",
            "variantchange:color",
            "variantchange:colour",
            "variantchange:imageset",
            "variantchange:precise",
            "variantunavailable"
        ];

        if (!window.Events || typeof window.Events.removeAllListeners !== "function") return;

        productSectionEvents.forEach(function (eventName) {
            window.Events.removeAllListeners(eventName);
        });
    }

    function initQuantitySelectors() {
        var templateEl = document.getElementById("JsQty");
        var quantityInputs = document.querySelectorAll('input[type="number"]:not(.price-facet-input)');
        var newQuantitySelectors = [];

        if (!templateEl || !window.Handlebars || !quantityInputs.length) return;

        Array.prototype.forEach.call(quantityInputs, function (input) {
            var currentQty = input.value;
            var currentQtyNumber = parseInt(currentQty, 10);
            var template = window.Handlebars.compile(templateEl.innerHTML);
            var wrapper = document.createElement("div");

            if (input.closest(".js-qty")) return;
            if (isNaN(currentQtyNumber)) currentQtyNumber = 1;

            wrapper.innerHTML = template({
                id: input.getAttribute("data-id"),
                itemQty: currentQty,
                itemAdd: currentQtyNumber + 1,
                itemMinus: currentQtyNumber - 1,
                inputName: input.getAttribute("name"),
                inputId: input.getAttribute("id")
            });

            input.parentNode.insertBefore(wrapper.firstElementChild, input.nextSibling);
            newQuantitySelectors.push(input.nextSibling);
            input.parentNode.removeChild(input);
        });

        Array.prototype.forEach.call(newQuantitySelectors, function (selector) {
            Array.prototype.forEach.call(selector.querySelectorAll(".js-qty__adjust"), function (button) {
                button.addEventListener("click", function () {
                    var qtySelector = button.parentElement.querySelector(".js-qty__num");
                    var qty = parseInt((qtySelector.value || "").replace(/\D/g, ""), 10);

                    if (isNaN(qty)) qty = 1;

                    if (button.classList.contains("js-qty__adjust--plus")) {
                        qty += 1;
                    } else {
                        qty -= 1;
                        if (qty <= 1) qty = 1;
                    }

                    qtySelector.value = qty;
                });
            });
        });
    }

    function reinitializeProduct() {
        if (window.theme && typeof window.theme.Product === "function") {
            var productPage = document.querySelector(".product-page.product-template");
            if (productPage) window.theme.Product(productPage);
        }

        callThemeMethod("backInStockform");
        callThemeMethod("lowStockform");
        callThemeMethod("breadcrumbsPos");
        callThemeMethod("showSelectedSwatchProdImages");
        callThemeMethod("checkOptionSelection");
        callThemeMethod("initImageZoom");
        callThemeMethod("sizeChartClickEvent");
        callThemeMethod("sizeChartSplitMobile");
        callThemeMethod("prodDescriptionToggle");
        callThemeMethod("makeStickySideColumns");
        callThemeMethod("shopifyReview");

        if (window.theme && window.theme.utils && window.theme.utils.stickyUtils && typeof window.theme.utils.stickyUtils.refresh === "function") {
            window.theme.utils.stickyUtils.refresh();
        }

        if (window.ajaxCart && typeof window.ajaxCart.initAddToCartButtons === "function") {
            window.ajaxCart.initAddToCartButtons();
        }

        initQuantitySelectors();

        if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === "function") {
            window.yotpoWidgetsContainer.initWidgets();
        }
    }

    function handleResponse(request, sections, newUrl, swatchOrders, selectedOptions, scrollY, starRatings) {
        var res = JSON.parse(request.responseText);

        sections.forEach(function (section) {
            var elementToReplace = document.getElementById(section.id);
            var sectionHTML = res[section.section];

            if (!elementToReplace || typeof sectionHTML === "undefined") return;

            elementToReplace.innerHTML = sectionHTML ? getSectionInnerHTML(sectionHTML, section.selector) : "";
            if (sectionHTML) executeScriptsFromHTML(sectionHTML);
        });

        preserveProfileOrder(swatchOrders.profile);
        preserveSwatchOrder(".swatch.color", swatchOrders.color);

        if (window.location.href !== newUrl) {
            window.history.replaceState(null, "", newUrl);
        }

        resetProductSectionEventListeners();
        restorePreservedStarRatings(starRatings);
        reinitializeProduct();
        restoreSelectedOptions(selectedOptions);
        filterProfilesForSelectedColor();
        restorePreservedStarRatings(starRatings);
        restoreScrollPosition(scrollY);
        isFetchingSections = false;
    }

    function fetchSections(url, sections, swatchOrders, selectedOptions, scrollY, starRatings) {
        if (isFetchingSections) return;
        isFetchingSections = true;

        var request = new XMLHttpRequest();
        var sectionParams = sections.map(function (section) {
            return section.section;
        }).join(",");
        var requestUrl = new URL(url, window.location.origin);

        requestUrl.searchParams.set("sections", sectionParams);
        requestUrl.hash = "";

        request.addEventListener("load", function () {
            if (request.status < 200 || request.status >= 300) {
                window.location.href = url;
                return;
            }

            try {
                handleResponse(request, sections, url, swatchOrders, selectedOptions, scrollY, starRatings);
            } catch (error) {
                window.location.href = url;
            }
        });
        request.addEventListener("error", function () {
            window.location.href = url;
        });
        request.open("GET", requestUrl.toString(), true);
        request.send();
    }

    function renderProfileProduct(url, swatchOrders, selectedOptions, scrollY, starRatings) {
        var allSections = getSectionsToRender(5);
        if (!allSections.length) {
            window.location.href = url;
            return;
        }

        fetchSections(url, allSections, swatchOrders, selectedOptions, scrollY, starRatings);
    }

    document.addEventListener("click", function (event) {
        var anchor = event.target && event.target.closest ? event.target.closest(".swatch.profile [data-href]") : null;
        if (!anchor || isFetchingSections) return;

        event.preventDefault();

        var profileValue = anchor.getAttribute("data-swatch-value");
        var fallbackUrl = anchor.getAttribute("data-href");
        var selectedColorHandle = getSelectedColorHandle();
        var colorMatchedUrl = getProfileUrlForSelectedColor(anchor);
        var swatchOrders = {
            profile: getProfileOrder(),
            color: getSwatchOrder(".swatch.color")
        };
        var selectedOptions = getSelectedOptions();
        var scrollY = getScrollY();
        var starRatings = getPreservedStarRatings();

        stopScrollAnimations();

        if (colorMatchedUrl) {
            renderProfileProduct(colorMatchedUrl, swatchOrders, selectedOptions, scrollY, starRatings);
            return;
        }

        if (selectedColorHandle) {
            filterProfilesForSelectedColor();
            return;
        }

        resolveProfileUrl(profileValue, fallbackUrl).then(function (url) {
            renderProfileProduct(url, swatchOrders, selectedOptions, scrollY, starRatings);
        });
    });

    document.addEventListener("change", function (event) {
        if (event.target && event.target.closest && event.target.closest(".swatch.color")) {
            scheduleProfileFilter();
        }
    });

    if (window.MutationObserver && document.body) {
        new MutationObserver(function (mutations) {
            var shouldFilter = mutations.some(function (mutation) {
                return Array.prototype.some.call(mutation.addedNodes, function (node) {
                    if (node.nodeType !== 1) return false;

                    return (node.matches && node.matches(".swatch.profile, .swatch.color")) ||
                        (node.querySelector && node.querySelector(".swatch.profile, .swatch.color"));
                });
            });

            if (shouldFilter) scheduleProfileFilter();
        }).observe(document.body, { childList: true, subtree: true });
    }

    filterProfilesForSelectedColor();
})();
